import { Component, OnInit } from "@angular/core";
import { TitleService } from 'src/app/_services/title.service';

@Component({
  selector: "order-delivery-settings-layout",
  templateUrl: "./order-delivery-settings.layout.html",
  host: { 'class': 'tab-content' },
  styleUrls: ['./order-delivery-settings.layout.scss']
})
export class OrderDeliverySettingsLayout implements OnInit {
  title = "cards.lexi_market_settings.order_delivery_settings.title";

  constructor(private _titleService: TitleService) { }

  public ngOnInit() {
    this._titleService.setTitle(this.title);
  }

}